module.exports = __webpack_public_path__ + "img/turbo_off.8f629d57.png";